import { List, Map } from 'immutable';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';

export function assert(condition, message) {
  if (!__DEV__) return condition;

  if (!condition) {
    throw new Error(`Assertion failed: ${message}`);
  }

  return condition;
}

function assertTypeof(type, stringType = 'your path type as function and forgot set special type for it') {
  return (value, prop) => {
    // eslint-disable-next-line valid-typeof
    const check = isFunction(type) ? type(value) : typeof value === type;
    const resultType = isFunction(type) ? stringType : type;

    return assert(check, `Expected "${prop}" to be a "${resultType}", received ${value}`);
  };
}

export const assertString = assertTypeof('string');
export const assertNumber = assertTypeof('number');
export const assertFunction = assertTypeof('function');
export const assertObject = assertTypeof(isObject, 'object');
export const assertBoolean = assertTypeof('boolean');

export const assertImList = assertTypeof((val) => val instanceof List, 'immutable.List');
export const assertImMap = assertTypeof((val) => val instanceof Map, 'immutable.Map');
